export const enum QuickStartStatus {
  Completed = 'completed',
  Skipped = 'skipped',
}
